import { Observable } from 'rxjs';
import { CreateTerminalDto } from '@app/data/dtos/tpv/register-terminal.dto';

/**
 * Port abstracto para el alta de terminales en el TPV (escritura, §4 del spec).
 * Permiso backend: IsAdmin. La `Idempotency-Key` es OPCIONAL aquí: la terminal
 * ya tiene clave natural (id_terminal). Si se provee y supera 255 chars → 400.
 */
export abstract class TerminalRegistrationRepository {
  abstract registerTerminal(
    dto: CreateTerminalDto,
    idempotencyKey?: string,
  ): Observable<void>;
}
